// 初始化数据
const modal = {
  goodsDetailData: [], //详情结果数据
  searchParams: {}, // 搜索传值
  total: 0, // 查询总数
  page: 1, // 当前页码
  size: 10, // 当前分页数
  tableLoading: false, // 列表loading
  action: '', //是否是编辑或者新增
  isShowSearch: false, //是否显示高级查询
  superClass: 0, //工具栏按钮
  selectedRowKeys: [], //选择的行
  tabList: [
    { name: '待发货', num: '' },
    { name: '已发货', num: '' },
    { name: '已签收', num: '' },
    { name: '已取消', num: '' },
  ],
  totalAmount: {},
  auditStatusObj: {
    //审核状态
    '-1': '未审核',
    0: '审核中',
    1: '审核通过',
    2: '审核驳回',
  },
  productBenchmarkingHeadResList: [
    { benchmarkingBbject: null, connectionCombinationWay: null, productBenchmarkingInfoList: [] },
  ],
};
export default modal;
